<template>
  <th v-if="isHeader">
    {{'Actions' | translate}}
  </th>
  <td v-else>
    <div class="custom-actions">
      <button class="btn btn-primary btn-sm mb-1 edit-button" @click="editReport(rowData)">
        <i class="icons icon-note"></i>&nbsp;{{ 'Edit' | translate }}
      </button>
      <button class="btn btn-info btn-sm mb-1" :disabled="generatingPdf" @click="createPdf(rowData)">
        <i class="fa fa-spinner fa-spin" v-if="generatingPdf"></i>
        <i class="fa fa-file-pdf-o" v-else></i>
        &nbsp;{{ 'Create PDF' | translate }}
      </button>
      <button class="btn btn-danger btn-sm mb-1 delete-button" @click="deleteReport(rowData)">
        <i class="icons icon-trash"></i>&nbsp;{{ 'Delete' | translate }}
      </button>
    </div>
  </td>
</template>

<script>
import Vue from 'vue'
import VuetableFieldMixin from 'vuetable-2/src/components/VuetableFieldMixin'

export default {
  mixins: [VuetableFieldMixin],
  props: {
    rowData: {
      type: Object,
      required: true
    },
    rowIndex: {
      type: Number
    }
  },
  data: function () {
    return {
      generatingPdf: false
    }
  },
  methods: {
    editReport: function (data) {
      this.$router.push('/report/edit/' + data.id)
    },
    createPdf: function (data) {
      var vm = this
      vm.generatingPdf = true

      this.$http.get('reports/weld/' + data.id + '?lang=' + Vue.i18n.locale(), { responseType: 'arraybuffer' }).then(function (pdfRes) {
        var blob = new Blob([pdfRes.body], { type: 'application/pdf' })
        var url = window.URL.createObjectURL(blob)
        var a = document.createElement('a')
        a.href = url
        var safeName = (data.name || 'report').replace(/[^a-zA-Z0-9_-]/g, '_')
        a.download = safeName + '_weld_report.pdf'
        document.body.appendChild(a)
        a.click()
        document.body.removeChild(a)
        window.URL.revokeObjectURL(url)
        vm.generatingPdf = false
      }).catch(function (err) {
        console.error('Failed to create PDF:', err)
        vm.generatingPdf = false
      })
    },
    deleteReport: function (data) {
      if (!confirm(this.$t('Are you sure?'))) return
      var vm = this
      this.$http.delete('weldreport/' + data.id).then(function () {
        vm.$parent.refresh()
      }).catch(function (err) {
        console.error('Failed to delete report:', err)
      })
    }
  }
}
</script>



// WEBPACK FOOTER //
// VueTableReportListActions.vue?22c7f8e9